import useCustomHook from '@/hooks/useCustomHook';

export default function useQuestionCard() {
  const { state, actions } = useCustomHook({
    defaultState: {
      showEnglishText: false,
    },
    actions: {
      toggleShowEnglishText: () => {
        actions.setState({ showEnglishText: !state.showEnglishText });
      },
    },
  });

  return { state, actions };
}
